import { LegacyJobCatalogFeatureEnabledDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { useJobCatalogRoleFilter } from 'modules/job_catalog/lib/filters/jobRole'

import { useEmployeesFilter } from './employees'
import { useLegalEntityFilter } from './legalEntity'
import { useTeamFilter } from './team'
import { useWorkplaceFilter } from './workplace'

export const useEmployeeFilters = () => {
  const { company } = useCurrentSession()

  const { data: legacyJobCatalogFeatureEnabledData } = useQuery(
    LegacyJobCatalogFeatureEnabledDocument,
    {
      fetchPolicy: 'network-only',
      variables: {
        companyId: company.id,
      },
    }
  )

  const hasLegacyJobCatalog =
    !!legacyJobCatalogFeatureEnabledData?.features?.featuresConnection?.totalCount

  const hasJobCatalogTreeFeature = !hasLegacyJobCatalog

  const workplaceFilter = useWorkplaceFilter()
  const teamFilter = useTeamFilter()
  const legalEntityFilter = useLegalEntityFilter()
  const jobCatalogRoleFilter = useJobCatalogRoleFilter({ hasJobCatalogTreeFeature })

  const reportingToFilter = useEmployeesFilter({
    label: i18n.t('employees.employees_list.filters.reporting_to'),
  })

  const timeoffManagerFilter = useEmployeesFilter({
    label: i18n.t('employees.employees_list.filters.timeoff_manager'),
  })

  return {
    filters: {
      workplace: workplaceFilter,
      team: teamFilter,
      reportingTo: reportingToFilter,
      timeoffManager: timeoffManagerFilter,
      legalEntity: legalEntityFilter,
      jobRole: jobCatalogRoleFilter,
    },
    hasJobCatalogTreeFeature,
  }
}

export type UseEmployeeFiltersResult = ReturnType<typeof useEmployeeFilters>
